angular
  .module("digitalLeasing.module")
  .component('download', {
    templateUrl: 'ng/components/digitalLeasing/qva/download/download.view.html',
    controllerAs: 'downloadCtrl',
    bindings: {
      assurances: "<",
      id: "<",
      checkDownload: "&",
      isPostVendita: "="
    },
    controller: function (

      $configService,
      $simulationService

    ) {
      var self = this;

      self.documents = [{}];

      self.$onInit = function () {

        self.assurances = self.assurances;
        self.id = self.id;
        self.toggles = [];
        self.getFiles();

      }


      self.getFiles = function () {

        self.isLoading = true;

        var input = {
          assicurazioni: self.assurances,
          idWfInstance: self.id,
          pv: self.isPostVendita
        }

        $simulationService
          .getUrlsDocAssicurazioni(input)
          .then(function (response) {
            if (response.documents.length === 0) {
              self.viewModeEmptyDocList = true;
              self.checkDownload({ areAllDocDownloaded: true });
              return;
            }
            self.documents = response.documents
              .map(function (element) {
                return {
                  description: element.description,
                  url: element.url
                }
              })
            self.isLoading = false;
          })
          .catch(function (error) {
            console.log("ERROR: ", error);
            self.isLoading = false;
          })
          .finally(function () {
            self.isLoading = false;
          })


      }

      self.generateDownloadLink = function (url) {

        var link =
          "/uni/downloadGeneric/service-infos" +
          url

        $download.getGenericDownload(link)
          .then(function (response) {
            console.log(response);
          })

      }


      self.downloadDoc = function (index, value) {
        self.toggles[index] = value;
        if (self.toggles.length === self.documents.length) {
          self.checkDownload({ areAllDocDownloaded: true });
        }
      };


    }

  });